module.exports = __webpack_public_path__ + "71edb46cd5e1531e0acd5997e377bc70.png";